module.exports = __webpack_public_path__ + "static/media/sortSvg.fe2ae52b.svg";